import {
  formatDate,
  formatTime
} from '@smarttransit/common'

function labelFromItems (items, value) {
  const match = (items || []).find((item) => item.value === value)
  return (match && match.text) || value
}

function audioDateUpdatedMs (dateUpdated) {
  return dateUpdated ? new Date(dateUpdated).getTime() : 0
}

function audioDateUpdatedLabel (dateUpdated) {
  if (!dateUpdated) {
    return ''
  }

  return `${formatTime(dateUpdated)}, ${formatDate(dateUpdated)}`
}

function decorateAudioFile (record, { url, locales, genericTypes }) {
  const decorated = Object.assign({}, record, {
    url,
    localeLabel: labelFromItems(locales, record.locale),
    dateUpdatedLabel: audioDateUpdatedLabel(record.dateUpdated),
    playbackKey: `${record.id}-${audioDateUpdatedMs(record.dateUpdated)}-${url || ''}`
  })

  if (genericTypes) {
    decorated.typeLabel = labelFromItems(genericTypes, record.type)
  }

  return decorated
}

async function attachSecureUrls (records, getUrlFn) {
  if (!records || !records.length) {
    return []
  }

  const urls = await Promise.all(records.map((record) => getUrlFn(record.id)))
  return records.map((record, index) => ({ record, url: urls[index] }))
}

export {
  decorateAudioFile,
  attachSecureUrls
}
